module.exports = __webpack_public_path__ + "img/CMBC-FPD.e1bc0ef8.png";